export { default } from './getLatestMobileAssessment';
